import React from 'react'
import { graphql } from 'gatsby'
import type { Offer } from '../mapper'

type EssentialsInfosForCareerSiteProps = {
  data: Offer
  color?: string
}

const EssentialsInfosForCareerSite: React.FC<
  EssentialsInfosForCareerSiteProps
> = ({ data, color = 'primary' }) => {
  const style = {
    color,
    borderColor: color,
  }

  return (
    <div className="container flex flex-col items-center gap-3 p-4 mx-auto lg:items-start">
      <div className="flex gap-2">
        {data.contractType && data.contractType !== 'Non précisé' && (
          <p className="px-3 py-1 text-sm border rounded-md" style={style}>
            {data.contractType}
          </p>
        )}
        {data.experienceRequirement &&
          data.experienceRequirement !== 'Non précisé' && (
            <p
              className="px-3 py-1 text-sm truncate border rounded-md"
              style={style}
            >
              {data.experienceRequirement}
            </p>
          )}
      </div>
      <div className="flex gap-2">
        {data.payRange && data.payRange !== 'Non précisé' && (
          <p className="px-3 py-1 text-sm border rounded-md" style={style}>
            {data.payRange}
          </p>
        )}
        {data.educationRequirement &&
          data.educationRequirement !== 'Non précisé' && (
            <p className="px-3 py-1 text-sm border rounded-md" style={style}>
              {data.educationRequirement}
            </p>
          )}
      </div>
      <p className="px-3 py-1 text-sm border rounded-md" style={style}>
        {data.startDate}
      </p>
    </div>
  )
}

export default EssentialsInfosForCareerSite

export const query = graphql`
  fragment OfferEssentialsInfos on STRAPI_ACCOUNTING_OFFER {
    contractType
    educationRequirement
    experienceRequirement
    startDate(locale: "")
    payRange {
      min
      max
    }
  }
`
